import { authenticatedInstance } from '../index/index.service';
import type { LoginResponse } from 'shared-models/browser';
import { extractServiceErrorMessage } from '../shared/service-error.util';

class LoginService {
    async login(username: string, password: string): Promise<LoginResponse> {
        try {
            const response = await authenticatedInstance.post<LoginResponse>('/login', { username, password });
            return response.data;
        } catch (error: unknown) {
            throw new Error(extractServiceErrorMessage(error, ''));
        }
    }
}

export const loginService = new LoginService();


